import Component from './OffersList';

export default Component;
